import { render, staticRenderFns } from "./Arrendadora.vue?vue&type=template&id=73131814"
import script from "./Arrendadora.vue?vue&type=script&lang=js"
export * from "./Arrendadora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports